// extracted by mini-css-extract-plugin
export default {"container":"Copter_container__uA96t","menus":"Copter_menus__DDE49","menu":"Copter_menu__xOR5E","target":"Copter_target__H3KL2","console":"Copter_console__fzuui"};